import { ChangeDetectionStrategy, Component } from "@angular/core";
import { FlexModule } from "@vp/shared/directives/flex";

@Component({
  selector: "vp-web-app-error",
  templateUrl: "./error.component.html",
  styleUrls: ["./error.component.scss"],
  standalone: true,
  imports: [FlexModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ErrorComponent {}
